import { authClient } from "./client";

export async function login(username, password) {
  const res = await authClient.post("/login", { username, password });
  return res.data;
}

export async function refresh() {
  const res = await authClient.get("/refresh");
  return res.data;
}

export async function logout() {
  return await authClient.post("/logout");
}

